export default class TreffHelper {
  constructor(el) {
    this.el = el;
    this.pagename = this.el.getAttribute('data-pagename');
    if (this.pagename === 'friends') {
      this.items2 = this.el.querySelectorAll('.friends-picture');
    } else {
      this.toggleLink = document.querySelector('.new-teasers-toggle-link');
      this.items = this.el.querySelectorAll('.profile-picture');
      this.banner = this.el.querySelectorAll('.profile-teasers-banner');
    }
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.resizeItems();
    $(this.toggleLink).on('click', () => {
      this.resizeItems();
    });
    $(window).on('resize', () => {
      this.resizeItems();
    });
  }

  resizeItems() {
    if (this.pagename === 'friends' && this.items2.length > 0) {
      this.items2.forEach(item => {
        $(item).height(this.calculateHeight(item, 1.4));
      });
    } else if (typeof this.items !== 'undefined' && this.items.length > 0) {
      this.items.forEach(item => {
        $(item).height(this.calculateHeight(item, 1.33333333));
      });
      console.log('items = ', this.items.length);
      this.banner.forEach(banner => {
        $(banner).css('background-color', '#ffcc33');
        $(banner).height(
          $(this.items[0])
            .parents('.panel-default')
            .height()
        );
      });
    }
  }

  calculateHeight(item, factor) {
    const newHight = $(item).width() * factor;
    const newHightValue = newHight === 0 ? 'auto' : newHight;
    return newHightValue;
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/treff_helper.js